import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';
import { isCpo } from 'site-modules/shared/utils/inventory-utils/is-cpo';
import { get } from 'lodash-es';
import { InventoryEntities } from 'client/data/models/inventory';

function VdpBackBtnUI({ className = null, vdpLink = '', isMobile = false, vehicle = {} }) {
  const isCpoType = isCpo(vehicle.type);
  const { make, model, year } = get(vehicle, 'vehicleInfo.styleInfo', {});

  return (
    <Link
      to={vdpLink}
      rel="nofollow"
      aria-disabled={false}
      tabIndex={0}
      className={classNames(className, { medium: isMobile })}
      data-testid="vdp-link"
    >
      <i className={`icon-arrow-left4 me-0_25 ${isMobile ? 'size-10' : 'size-12'} `} aria-hidden />
      Back to {isCpoType && isMobile ? 'Certified ' : ''} {year} {make} {model}
    </Link>
  );
}

VdpBackBtnUI.propTypes = {
  className: PropTypes.string,
  vdpLink: PropTypes.string,
  isMobile: PropTypes.bool,
  vehicle: InventoryEntities.InventoryVin,
};

export const VdpBackBtn = React.memo(VdpBackBtnUI);
